(function () {
  function init(root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('.rbe-pl'));
    var panels = root.querySelectorAll('.rbe-panel');
    if (!pills.length) return;

    function activate(pill, moveFocus) {
      var key = pill.getAttribute('data-key');
      pills.forEach(function (p) {
        var selected = p === pill;
        p.setAttribute('aria-selected', selected ? 'true' : 'false');
        p.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        panel.setAttribute('data-active', panel.getAttribute('data-key') === key ? 'true' : 'false');
      });
      if (moveFocus) pill.focus();
    }

    pills.forEach(function (pill, index) {
      pill.addEventListener('click', function () {
        activate(pill, false);
      });
      pill.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = pills[(index + 1) % pills.length];
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = pills[(index - 1 + pills.length) % pills.length];
        else if (event.key === 'Home') target = pills[0];
        else if (event.key === 'End') target = pills[pills.length - 1];
        if (!target) return;
        event.preventDefault();
        activate(target, true);
      });
    });
  }

  document.querySelectorAll('[data-rbe-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-rbe-root]').forEach(init);
  });
})();
